<script lang="ts">
  import type { Snippet } from 'svelte';

  let {
    label,
    collapsed = false,
    children
  }: {
    label: string;
    collapsed?: boolean;
    children: Snippet;
  } = $props();
</script>

<section class="section" class:collapsed>
  {#if !collapsed}
    <span class="label">{label}</span>
  {/if}
  <div class="items">
    {@render children()}
  </div>
</section>

<style>
  /* Réplica del .nav-group del IAGIT.
     Border-bottom 1px en cada grupo excepto el último. */

  .section {
    display: flex;
    flex-direction: column;
    margin-bottom: var(--space-4);
    padding-bottom: var(--space-4);
    border-bottom: var(--border-width) solid var(--color-border);
  }

  /* El último grupo no lleva separador (el footer ya tiene su border-top) */
  .section:last-child {
    border-bottom: none;
    margin-bottom: 0;
    padding-bottom: 0;
  }

  .section.collapsed {
    align-items: center;
    margin-bottom: var(--space-2);
    padding-bottom: var(--space-2);
  }

  .label {
    padding: 0 14px 4px;
    font-family: var(--font-body, var(--font-sans));
    font-size: 0.65rem;
    font-weight: 600;
    letter-spacing: 0.15em;
    text-transform: uppercase;
    color: var(--color-text-muted);
    opacity: 0.8;
  }

  .items {
    display: flex;
    flex-direction: column;
  }
</style>